/**
 * TASK-109 (AR-08) — react-query hook for the read-only merge preview.
 * Disabled until a target is selected (targetId !== null), so opening the
 * dialog before picking a target issues no request.
 */
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchMergePreview } from '../api/recordService';
export var useMergePreview = function (sourceId, targetId) {
    var ky = useOkapiKy();
    return useQuery(['merge-preview', sourceId, targetId], function () { return fetchMergePreview(ky, sourceId, targetId); }, { enabled: Boolean(sourceId) && Boolean(targetId) });
};
export default useMergePreview;
